import { render, staticRenderFns } from "./DrawCateEdit.vue?vue&type=template&id=22ba907e&scoped=true"
import script from "./DrawCateEdit.vue?vue&type=script&lang=js"
export * from "./DrawCateEdit.vue?vue&type=script&lang=js"
import style0 from "./DrawCateEdit.vue?vue&type=style&index=0&id=22ba907e&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ba907e",
  null
  
)

export default component.exports